import axios from 'axios';
import { useSelector } from 'react-redux';

export default axios.create({
  baseURL: 'https://fonefusion.ondemandcrm.co', //window.location.origin, //"https://murdartbyhari.ondemandcrm.co", //window.location.origin, //"https://filly.ondemandcrm.co",  //"https://ecommerce.ondemandcrm.co", //window.location.origin,
  headers: {
    'Content-type': 'application/json',
  },
});
